export default "__VITE_ASSET__BMH8I$Bx__"